import axios from "axios";

export const OCCUPATION_CATEGORY_URL = "/OccupationCategory";

/** Belli Bir Meslek Kategorisi Listesini Elde Eder */
export function getCategories(queryParams) {
  return axios.post(`${OCCUPATION_CATEGORY_URL}/GetOccupationCategories`, queryParams);
}

/** Belli Bir Meslek Kategorisi Listesini Sayfalama Olmadan Elde Eder */
export function getAllCategories(queryParams) {
  return axios.post(`${OCCUPATION_CATEGORY_URL}/GetAllOccupationCategories`, queryParams);
}

/** Yeni Bir Meslek Kategorisi Elde Eder */
export function getNewCategory() {
  return axios.get(OCCUPATION_CATEGORY_URL);
}

/** Belli Bir Meslek Kategorisini Elde Eder */
export function getCategory(id) {
  return axios.get(`${OCCUPATION_CATEGORY_URL}/${id}`);
}

/** Belli Bir Meslek Kategorisini Kaydeder */
export function saveCategory(category) {
  return axios.post(OCCUPATION_CATEGORY_URL, category);
}

/** Belli Bir Meslek Kategorisi Listesini Siler */
export function deleteCategories(ids) {
  return axios.post(`${OCCUPATION_CATEGORY_URL}/Delete`, { ids });
}